import { useCallback, useState } from "react";

function useTutorialIntroModalContentEvents({ onContentClick }: { onContentClick?: () => void }) {
    const [isContentClicked, setIsContentClicked] = useState(false);
    const [isContentHovered, setIsContentHovered] = useState(false);

    const handleContentClick = useCallback(() => {
        setIsContentClicked(true);
        if (onContentClick) {
            onContentClick();
        }
    }, [onContentClick]);

    const handleContentMouseEnter = useCallback(() => {
        setIsContentHovered(true);
    }, []);

    const handleContentMouseLeave = useCallback(() => {
        setIsContentHovered(false);
    }, []);

    return { isContentClicked, isContentHovered, handleContentClick, handleContentMouseEnter, handleContentMouseLeave }
}

export default useTutorialIntroModalContentEvents;
